import { render, staticRenderFns } from "./AboutSectionThree.vue?vue&type=template&id=8f91fa6a&"
import script from "./AboutSectionThree.vue?vue&type=script&lang=js&"
export * from "./AboutSectionThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports